import {Typography} from 'components/Typography';
import style from './style.module.scss';

interface IProductOutOfStockLineProps {
    hasSimilar: boolean;
}

export const ProductOutOfStockLine = ({hasSimilar}: IProductOutOfStockLineProps) => {
    const title = hasSimilar ? 'Этот товар закончился, но есть замена' : 'Этот товар закончился';

    return (
        <div className={style.productOutOfStockLineContainer}>
            <Typography color={'gray60'} variants={{DT: 'label-16-m', TB: 'label-16-m', MB: 'label-14-m'}}>
                {title}
            </Typography>
        </div>
    );
};
